import React, { useState, useEffect, useCallback } from "react";
import ShopSidebar from "../Mescomposants/ShopSidebar";
import { crudData } from "../services/apiService";
import ProductWrap from "../Mescomposants/Product/ProductWrap";
import Pagination from "../Mescomposants/Pagination/Pagination"; // Import the new Pagination component
import { useSearchParams } from "react-router-dom";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { generatePageNumbers } from "../services/lib";

const Shop = ({ param, defaultImage, onSuccess }) => {
    const [totalPage, setTotalPage] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeFilters, setActiveFilters] = useState(() => {
        const filters = {
            especes: [],
            categories: [],
            fournisseurs: [],
            search: "",
        };
        searchParams.forEach((value, key) => {
            filters[key] = value.split(",");
        });
        delete filters.limit;
        delete filters.page;
        return filters;
    });
    const [page, setPage] = useState(() => {
        return parseInt(searchParams.get("page")) || 1;
    });
    const [limit, setLimit] = useState(() => {
        return parseInt(searchParams.get("limit")) || 20;
    });

    useEffect(() => {
        const updatedFilters = {
            especes: [],
            categories: [],
            fournisseurs: [],
            search: "",
        };

        searchParams.forEach((value, key) => {
            updatedFilters[key] = value.split(",");
        });

        setActiveFilters(updatedFilters);
    }, [searchParams]);

    const handleActiveFilters = useCallback(
        (filterName, filterValue) => {
            setActiveFilters((prevActiveFilters) => {
                const updatedFilters = structuredClone(prevActiveFilters);

                if (!updatedFilters[filterName]) {
                    updatedFilters[filterName] = [filterValue];
                } else if (updatedFilters[filterName].includes(filterValue)) {
                    updatedFilters[filterName] = updatedFilters[
                        filterName
                    ].filter((val) => val !== filterValue);
                } else {
                    updatedFilters[filterName].push(filterValue);
                }

                const params = new URLSearchParams();
                Object.keys(updatedFilters).forEach((key) => {
                    if (updatedFilters[key].length > 0) {
                        params.set(key, updatedFilters[key].join(","));
                    }
                });
                params.set("limit", limit);
                params.set("page", 1);
                setSearchParams(params);

                return updatedFilters;
            });
        },
        [setSearchParams, limit]
    );

    const handleClearActiveFilters = () => {
        setSearchParams({});
    };

    const goToPage = (page) => {
        const params = new URLSearchParams(searchParams);
        params.set("page", page);
        setSearchParams(params);
        setPage(page);
    };

    const handleSetLimit = (limit) => {
        const params = new URLSearchParams(searchParams);
        params.set("limit", limit);
        params.set("page", 1);
        setSearchParams(params);
        setPage(1);
        setLimit(limit);
    };

    const handleSearch = (e) => {
        const params = new URLSearchParams(searchParams);
        params.set("page", 1);
        params.set("search", e);
        setSearchParams(params);
        setPage(1);
        setActiveFilters({
            ...activeFilters,
            search: e,
        });
    };

    const fetchProducts = async (activeFilters) => {
        const data = new URLSearchParams();

        for (const key in activeFilters) {
            if (key === "search") {
                data.append("FILTER_OPTIONS[search]", activeFilters[key]);
            }
            if (key === "especes") {
                activeFilters[key].forEach((value) => {
                    data.append("FILTER_OPTIONS[str_proespece][]", value);
                });
            }
            if (key === "categories") {
                activeFilters[key].forEach((value) => {
                    data.append("FILTER_OPTIONS[str_procateg][]", value);
                });
            }
            if (key === "fournisseurs") {
                // alert("str_progamme");
                activeFilters[key].forEach((value) => {
                    data.append("FILTER_OPTIONS[str_progamme][]", value);
                });
            }
        }

        data.append("LIMIT", limit);
        data.append("PAGE", page);
        data.append("mode", "listProduct");

        try {
            const response = await crudData(data, "StockManager.php", false);
            setTotalPage(() => {
                return Math.ceil(response.data["total"] / limit);
            });
            return response.data["products"];
        } catch (error) {
            console.error(error);
        }
    };
    // Données de l'API récuperées par useQuery 
    const { data, isLoading, isFetching } = useQuery({
        queryKey: ["products", activeFilters, page, limit],
        queryFn: () => fetchProducts(activeFilters),
        placeholderData: keepPreviousData,
    });

    const [pageNumbers, setPageNumbers] = useState([]);
    useEffect(() => {
        setPageNumbers(generatePageNumbers(totalPage, page));
    }, [page, totalPage]);

    return (
        <div className={` ${param.userData ? "bgUserConnected" : ""}`}>
            <div className="page-wrapper">
                <main className="main mb-0 pb-1">
                    <div className="page-content">
                        <div className="container pt-5">
                            <div
                                className="shop-content row mb-10 page-container m-0 ml-0"
                                style={{ gap: "20px" }}
                            >
                                <ShopSidebar

                                    onFilterChange={handleActiveFilters}
                                    activeFilters={activeFilters}
                                    onResetAllFilters={handleClearActiveFilters}
                                />

                                <div className="main-content pr-0 pl-0">
                                    {/* Search bar */}
                                    <div className="search-bar mb-4" style={{}}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{
                                                color: "#336699",
                                                borderColor: "#336699",
                                                borderWidth: "2px",
                                            }}
                                            placeholder="Rechercher un produit..."
                                            value={activeFilters.search}
                                            onChange={(e) =>
                                                handleSearch(e.target.value)
                                            }
                                        />
                                    </div>

                                    {(isLoading || (isFetching && !data)) ? (
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: "80px 0",
                                            minHeight: "300px",
                                        }}>
                                            <i className="fas fa-spinner fa-spin" style={{ color: "#3B5998", fontSize: "40px", marginBottom: "15px" }}></i>
                                            <span style={{ color: "#3B5998", fontWeight: "600", fontSize: "16px" }}>Chargement en cours...</span>
                                        </div>
                                    ) : data !== undefined &&
                                        data.length > 0 ? (
                                        <div className="product-wrapper row cols-xl-4 cols-md-3 cols-sm-2 cols-2">
                                            {data.map((product) => (
                                                <ProductWrap
                                                    key={product.ArtID}
                                                    product={product}
                                                    defaultImage={defaultImage}
                                                    urlBaseImage={
                                                        param.urlBaseImage
                                                    }
                                                    userData={param.userData}
                                                    // col_css="col-xl-3 col-lg-3 col-4"
                                                    col_css="d-flex justify-content-center w"
                                                    onSuccess={onSuccess}
                                                />
                                            ))}
                                        </div>
                                    ) : (
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "60px 20px",
                                            textAlign: "center",
                                            animation: "fadeInUp 0.6s ease-out",
                                        }}>
                                            {/* Illustration SVG — Loupe avec boîte vide */}
                                            <div style={{
                                                width: "200px",
                                                height: "200px",
                                                marginBottom: "30px",
                                                animation: "floatBounce 3s ease-in-out infinite",
                                            }}>
                                                <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    {/* Cercle de fond */}
                                                    <circle cx="100" cy="100" r="90" fill="#E8EFF9" opacity="0.5" />
                                                    {/* Boîte ouverte */}
                                                    <rect x="55" y="85" width="90" height="65" rx="8" fill="#3B5998" opacity="0.15" stroke="#3B5998" strokeWidth="2.5" />
                                                    {/* Rabats de la boîte */}
                                                    <path d="M55 85 L75 60 L100 75 L125 60 L145 85" fill="#E8EFF9" stroke="#3B5998" strokeWidth="2.5" strokeLinejoin="round" />
                                                    {/* Étoiles scintillantes autour */}
                                                    <circle cx="45" cy="55" r="3" fill="#5B7EC2" opacity="0.6">
                                                        <animate attributeName="opacity" values="0.6;0.2;0.6" dur="2s" repeatCount="indefinite" />
                                                    </circle>
                                                    <circle cx="160" cy="65" r="2.5" fill="#3B5998" opacity="0.5">
                                                        <animate attributeName="opacity" values="0.5;0.1;0.5" dur="2.5s" repeatCount="indefinite" />
                                                    </circle>
                                                    <circle cx="155" cy="140" r="2" fill="#5B7EC2" opacity="0.4">
                                                        <animate attributeName="opacity" values="0.4;0.1;0.4" dur="1.8s" repeatCount="indefinite" />
                                                    </circle>
                                                    <circle cx="38" cy="130" r="2.5" fill="#3B5998" opacity="0.5">
                                                        <animate attributeName="opacity" values="0.5;0.15;0.5" dur="2.2s" repeatCount="indefinite" />
                                                    </circle>
                                                    {/* Loupe */}
                                                    <circle cx="115" cy="105" r="22" fill="none" stroke="#3B5998" strokeWidth="3" />
                                                    <line x1="131" y1="121" x2="148" y2="138" stroke="#3B5998" strokeWidth="4" strokeLinecap="round" />
                                                    {/* Point d'interrogation dans la loupe */}
                                                    <text x="115" y="114" textAnchor="middle" fill="#3B5998" fontSize="22" fontWeight="bold" fontFamily="Arial">?</text>
                                                </svg>
                                            </div>

                                            {/* Titre */}
                                            <h3 style={{
                                                fontSize: "22px",
                                                fontWeight: "700",
                                                color: "#3B5998",
                                                margin: "0 0 10px 0",
                                                letterSpacing: "0.3px",
                                            }}>
                                                Aucun produit trouvé
                                            </h3>

                                            {/* Sous-titre */}
                                            <p style={{
                                                fontSize: "15px",
                                                color: "#6C757D",
                                                margin: "0 0 25px 0",
                                                maxWidth: "380px",
                                                lineHeight: "1.6",
                                            }}>
                                                Essayez d'autres mots clés ou supprimez les filtres de recherche pour trouver ce que vous cherchez.
                                            </p>

                                            {/* Bouton CTA */}
                                            <button
                                                onClick={() => window.location.reload()}
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    padding: "12px 28px",
                                                    background: "linear-gradient(135deg, #3B5998, #5B7EC2)",
                                                    color: "#FFFFFF",
                                                    border: "none",
                                                    borderRadius: "8px",
                                                    fontSize: "15px",
                                                    fontWeight: "600",
                                                    cursor: "pointer",
                                                    boxShadow: "0 4px 15px rgba(59, 89, 152, 0.25)",
                                                    transition: "all 0.3s ease",
                                                }}
                                                onMouseOver={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(59, 89, 152, 0.35)"; }}
                                                onMouseOut={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 15px rgba(59, 89, 152, 0.25)"; }}
                                            >
                                                <i className="fas fa-redo" style={{ fontSize: "13px" }}></i>
                                                Réinitialiser les filtres
                                            </button>

                                            {/* Injection du CSS pour les animations */}
                                            <style>{`
                                                @keyframes fadeInUp {
                                                    from { opacity: 0; transform: translateY(20px); }
                                                    to { opacity: 1; transform: translateY(0); }
                                                }
                                                @keyframes floatBounce {
                                                    0%, 100% { transform: translateY(0); }
                                                    50% { transform: translateY(-10px); }
                                                }
                                            `}</style>
                                        </div>
                                    )}
                                    <Pagination
                                        currentPage={page}
                                        totalPages={totalPage}
                                        onPageChange={goToPage}
                                        pageNumbers={pageNumbers}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Shop;
